export const MAX_NAME_LENGTH = 100
export const MAX_EMAIL_LENGTH = 255
export const MAX_HISTORY_NUMBER = 2147483647
export const MAX_DIAGNOSIS_SUMMARY_LENGTH = 500
export const EMAIL_REGEX = /^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
export const NAME_REGEX = /^[a-zA-ZáéíóúÁÉÍÓÚñÑüÜ\s'-]+$/

export interface ValidationResult {
  isValid: boolean
  error?: string
}

export const validateName = (name: string | undefined): ValidationResult => {
  if (!name || name.trim().length === 0) {
    return { isValid: false, error: 'required' }
  }
  if (name.length > MAX_NAME_LENGTH) {
    return { isValid: false, error: 'tooLong' }
  }
  if (!NAME_REGEX.test(name)) {
    return { isValid: false, error: 'invalidFormat' }
  }
  return { isValid: true }
}

export const validateEmail = (email: string | undefined): ValidationResult => {
  if (!email || email.trim().length === 0) {
    return { isValid: false, error: 'required' }
  }
  if (email.length > MAX_EMAIL_LENGTH) {
    return { isValid: false, error: 'tooLong' }
  }
  if (!EMAIL_REGEX.test(email)) {
    return { isValid: false, error: 'invalidFormat' }
  }
  return { isValid: true }
}

export const validateHistoryNumber = (
  historyNumber: number | string | undefined
): ValidationResult => {
  if (!historyNumber) {
    return { isValid: false, error: 'required' }
  }
  const numValue = Number(historyNumber)
  if (isNaN(numValue) || numValue <= 0) {
    return { isValid: false, error: 'invalidFormat' }
  }
  if (numValue > MAX_HISTORY_NUMBER) {
    return { isValid: false, error: 'tooLarge' }
  }
  return { isValid: true }
}

export const validateDiagnosisSummary = (text: string | undefined): ValidationResult => {
  if (!text || text.trim().length === 0) {
    return { isValid: false, error: 'required' }
  }
  if (text.length > MAX_DIAGNOSIS_SUMMARY_LENGTH) {
    return { isValid: false, error: 'tooLong' }
  }
  return { isValid: true }
}

export const validateRequiredText = (text: string | undefined): ValidationResult => {
  if (!text || text.trim().length === 0) {
    return { isValid: false, error: 'required' }
  }
  return { isValid: true }
}

export const validateDate = (date: Date | undefined): ValidationResult => {
  if (!date) {
    return { isValid: false, error: 'required' }
  }
  const dateObj = new Date(date)
  if (isNaN(dateObj.getTime())) {
    return { isValid: false, error: 'invalidFormat' }
  }
  if (dateObj > new Date()) {
    return { isValid: false, error: 'invalidFormat' }
  }
  return { isValid: true }
}

export const sanitizeNumericInput = (
  value: string,
  maxValue: number = MAX_HISTORY_NUMBER
): string => {
  const sanitized = value.replace(/\D/g, '')
  if (sanitized === '' || Number(sanitized) <= maxValue) {
    return sanitized
  }
  return value.slice(0, -1).replace(/\D/g, '')
}
